import { useRef } from 'react'
import UP from '../images/dra_01.png'
import DOWN from '../images/pua_01.png'

export default function useHighLowPoints() {
  const chosenPointX = useRef({
    high: undefined,
    low: undefined,
  })

  function render(chart) {
    const mainSeries = chart.get('main')
    const iconsSeries = chart.get('high-low-icons')
    let maxValue, minValue, _chosenMaxPoint, _chosenMinPoint
    const gap = getGapByPeriod(chart?.period)

    mainSeries.points.forEach(function (point) {
      if (!point) return

      if (!maxValue || maxValue < point.high) {
        maxValue = point.high
        _chosenMaxPoint = point
      }
      if (!minValue || minValue > point.low) {
        minValue = point.low
        _chosenMinPoint = point
      }
    })

    if (
      (_chosenMaxPoint && chosenPointX.current.high !== _chosenMaxPoint.x) ||
      (_chosenMinPoint && chosenPointX.current.low !== _chosenMinPoint.x)
    ) {
      const price = {
        high: mainSeries.yData[_chosenMaxPoint.x][1],
        low: mainSeries.yData[_chosenMinPoint.x][2],
      }
      const average = (price.high + price.low) / 2

      chosenPointX.current = {
        high: _chosenMaxPoint.x,
        low: _chosenMinPoint.x,
      }
      iconsSeries.setData([])
      iconsSeries.addPoint(
        {
          x: _chosenMaxPoint.x,
          y: price.high + getTick(average) * gap,
          marker: {
            symbol: `url(${UP})`,
            width: 17,
            height: 34,
          },
        },
        false,
        false
      )
      iconsSeries.addPoint(
        {
          x: _chosenMinPoint.x,
          y: price.low - getTick(average) * gap,
          marker: {
            symbol: `url(${DOWN})`,
            width: 17,
            height: 34,
          },
        },
        false,
        false
      )
      iconsSeries.show()
    }
  }

  return { render }
}

function getTick(price) {
  if (price >= 500000) return 1000
  if (price >= 200000) return 500
  if (price >= 50000) return 100
  if (price >= 20000) return 50
  if (price >= 5000) return 10
  if (price >= 2000) return 5
  return 1
}

function getGapByPeriod(period) {
  switch (period) {
    case 'minutes': {
      return 1
    }
    case 'days': {
      return 20
    }
    case 'weeks': {
      return 80
    }
    case 'months': {
      return 150
    }
    default: {
      return 1
    }
  }
}
